import { render, staticRenderFns } from "./PromoUsage.vue?vue&type=template&id=1cbe42a3"
import script from "./PromoUsage.vue?vue&type=script&lang=js"
export * from "./PromoUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports